import * as React from 'react';
import { graphql } from 'react-apollo';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { actions } from 'actions';
import { PositionDetailModalView } from 'components/PositionDetailsModal';
import Footer from './components/Footer';
import { Buy } from './components/Buy';
import Sell from './components/Sell';
import { mapStateToProps, Data, SelectorResult, responseToProps } from './selectors';
import * as query from './query.gql';
import {
  IdeaPositionDetailsQuery,
  IdeaPositionDetailsQueryVariables,
} from './__generated__/IdeaPositionDetailsQuery';

export interface Props {}

const mapDispatchToProps = {
  close: actions.hideDetailModal,
};

type BodyProps = { position: Data['position'] };

type Enhanced = Props & SelectorResult & typeof mapDispatchToProps & Data;

const enhance = compose<Enhanced, Props>(
  connect(mapStateToProps, mapDispatchToProps),
  graphql<
    Props & SelectorResult,
    IdeaPositionDetailsQuery,
    IdeaPositionDetailsQueryVariables,
    Data
  >(query, {
    skip: ({ positionId }) => !positionId,
    options: ({ positionId }) => {
      return {
        variables: {
          id: positionId!,
        },
        errorPolicy: 'all',
      };
    },
    props: responseToProps,
  })
);

const Body: React.FC<BodyProps> = ({ position }) => {
  if (!position) {
    return null;
  }

  const { idea } = position;
  const ticker = idea?.currentPrice?.exchangeTicker || null;
  const category = idea?.category;

  return (
    <>
      {position.history.map((transaction, i) => {
        switch (transaction.__typename) {
          case 'Investment_BuyAndHoldPositionBuy':
            return <Buy key={i} transaction={transaction} ticker={ticker} category={category} />;
          case 'Investment_BuyAndHoldPositionSell':
            return <Sell key={i} transaction={transaction} ticker={ticker} category={category} />;
        }
      })}
    </>
  );
};

const IdeaPositionDetailsModal: React.FC<Enhanced> = ({ close, position, loading }) => (
  <PositionDetailModalView
    footer={<Footer position={position} />}
    isLoading={loading}
    onClose={close}
    data-testid="idea-position-details-modal"
  >
    <Body position={position} />
  </PositionDetailModalView>
);

export default enhance(IdeaPositionDetailsModal);
